<template>
  <div>
    <h1>Application Help View</h1>
    <v-row>
      <v-col cols="12" xs="12" sm="12" lg="10">
        
      </v-col>
    </v-row>
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
export default {
  name: "AppHelpPage",
  mixins: [uiView],
  components: {  },
  props: {},
  watch: {},
  mounted() {
    // this.globalSnackbar = false;
  },
  data: () => ({
    // showNotification: this.globalNotification.snackbar === null ? false : true,
  }),
  methods: {
    dialogOk() {
      alert("Ok");
    },
  },
};
</script>
<style lang="scss">
</style>
